<script>
import Layout from '@layouts/main.vue'
import SubBubbleAgreementsContainer from '@/components/subBubbleAgreement/sub-bubble-agreements-container.vue'

export default {
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'Sub Bubble Agreements' }],
    }
  },
  components: { Layout, SubBubbleAgreementsContainer },
  props: {
    clientId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    isValidClientId() {
      return !isNaN(this.clientId)
    },
    clientIdFormatted() {
      return this.isValidClientId ? Number(this.clientId) : null
    },
  },
}
</script>

<template>
  <Layout>
    <v-alert v-if="!isValidClientId" type="warning">{{
      $t('general.invalidUrl')
    }}</v-alert>
    <SubBubbleAgreementsContainer v-else :client-id="clientIdFormatted" />
  </Layout>
</template>
